export const DEBT_DETAIL_ITEMS_PER_PAGE = 10;

export const POSSESSOR_FILTER_OPTIONS = [
  { value: '', label: 'Todos' },
  { value: 'true', label: 'Poseedor de la unidad' },
  { value: 'false', label: 'Sin poseedor' },
];

export const DEBT_DETAIL_EXPORT_PREFIX = 'Detalle_Mora';
